import React, { useState, useEffect, useMemo } from 'react';
import IconItem from 'components/common/icon/IconItem';
import IconButton from 'components/common/IconButton';
import axios from 'helpers/api';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import TableShimmer from './TableShimmer';

const DiseaseCodeTable = (props) => {
    const [diseaseCodes, setDiseaseCodes] = useState([]);
    const [statusFilter, setStatusFilter] = useState('active');
    const [loading, setLoading] = useState(true);

    function handleEditInput(editValue) {
        props.onCallEditParent(editValue);
    }

    const columns = useMemo(() => [
        {
            accessorKey: 'code',
            header: 'Code',
            meta: {
                headerProps: { className: 'pe-1 text-start text-900' }
            }
        },
        {
            accessorKey: 'description',
            header: 'Description',
            meta: {
                headerProps: { className: 'pe-1 col-lg-6 text-start text-900' }
            }
        },
    ], []);

    useEffect(() => {
        async function fetchDiseaseCodes() {
            setLoading(true);
            let tokenStr = localStorage.getItem("accessToken");
            try {
                let res;
                try {
                    res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/patients/list-icd/`, {
                        headers: { 'Authorization': `Bearer ${tokenStr}` }
                    });
                } catch (e) {
                    console.log(e);
                }

                const rawData = res?.data?.patient_icd?.data || res?.data?.data;
                const isStatusOk = res?.data?.patient_icd?.status || res?.data?.status;
                if (isStatusOk && rawData) {
                    const results = rawData.map(value => ({
                        code: value.code,
                        description: value.description,
                        disease_id: value.id,
                        is_active: value.is_active
                    }));
                    setDiseaseCodes(results);
                } else {
                    setDiseaseCodes([]);
                }
            } catch (err) {
                toast.info("No Diagnosis Codes found in this list");
                setDiseaseCodes([]);
            } finally {
                setLoading(false);
            }
        }

        fetchDiseaseCodes();
    }, [props.trigger]);

    const filteredData = useMemo(() => {
        return diseaseCodes.filter(item => {
            const isActive = item.is_active == 1 || item.is_active === '1' || item.is_active === true;
            if (statusFilter === 'active') return isActive;
            if (statusFilter === 'inactive') return !isActive;
            return true;
        });
    }, [diseaseCodes, statusFilter]);

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Row className="g-2 align-items-center mb-3">
                    <Col md={4}>
                        <AdvanceTableSearchBox placeholder="Search..." />
                    </Col>
                </Row>
                {loading ? (
                    <TableShimmer />
                ) : filteredData.length > 0 ? (
                    <AdvanceTable
                        headerClassName="bg-200 text-nowrap align-middle text-center"
                        rowClassName="text-nowrap align-middle"
                        tableProps={{
                            size: 'lg',
                            striped: true,
                            className: 'fs-10 mb-0'
                        }}
                    />
                ) : (
                    <div className="d-flex justify-content-center align-items-center text-center py-4">
                        <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                    </div>
                )}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
        </div>
    );
};

export default DiseaseCodeTable;
